(() => {
  if (customElements.get('gs-colour-match')) return;

  class GsColourMatch extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.swatches = Array.from(this.querySelectorAll('[data-gs-cm-pick]'));
      this.panels = Array.from(this.querySelectorAll('[data-gs-cm-panel]'));
      this.swatches.forEach((button) => {
        button.addEventListener('click', () => this.show(button.dataset.gsCmPick));
      });
      this.panels.forEach((panel) => {
        const track = panel.querySelector('[data-gs-cm-track]');
        const prev = panel.querySelector('[data-gs-cm-prev]');
        const next = panel.querySelector('[data-gs-cm-next]');
        if (!track) return;
        const step = () => {
          const card = track.firstElementChild;
          const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          return card ? card.getBoundingClientRect().width + gap : track.clientWidth;
        };
        const update = () => {
          const max = track.scrollWidth - track.clientWidth - 2;
          if (prev) prev.disabled = track.scrollLeft <= 2;
          if (next) next.disabled = track.scrollLeft >= max;
        };
        if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step() }));
        if (next) next.addEventListener('click', () => track.scrollBy({ left: step() }));
        track.addEventListener('scroll', update, { passive: true });
        panel.gsUpdate = update;
        update();
      });
    }

    show(key) {
      this.swatches.forEach((button) => {
        button.setAttribute('aria-pressed', button.dataset.gsCmPick === key ? 'true' : 'false');
      });
      this.panels.forEach((panel) => {
        const on = panel.dataset.gsCmPanel === key;
        panel.hidden = !on;
        if (on) {
          const track = panel.querySelector('[data-gs-cm-track]');
          if (track) track.scrollLeft = 0;
          if (panel.gsUpdate) panel.gsUpdate();
        }
      });
    }
  }

  customElements.define('gs-colour-match', GsColourMatch);
})();
